import {Component, ViewEncapsulation} from '@angular/core';
import {DcpConfiguratorSinglePageFormComponent} from '@dcp/configurator';
import {ConfigureServiceErrorComponent} from '../../../error-handling/configure-service-error/configure-service-error.component';

@Component({
  templateUrl: './custom-dcp-configurator-single-page-form.component.html',
  styleUrl: './custom-dcp-configurator-single-page-form.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [DcpConfiguratorSinglePageFormComponent, ConfigureServiceErrorComponent],
})
export class CustomDcpConfiguratorSinglePageFormComponent {
  hideConfiguration: boolean = false;
}
